import { render, staticRenderFns } from "./PmtaCampaign.vue?vue&type=template&id=4510ba55&scoped=true"
import script from "./PmtaCampaign.vue?vue&type=script&lang=js"
export * from "./PmtaCampaign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4510ba55",
  null
  
)

export default component.exports